import { buildQueryParams } from '../apiHelpers';
import { _request,APIBaseResponse, APIMethod } from '../index';

const TENANTS_PATH_PREFIX = '/tenants';
const GLOBAL_ROLE_MEMBERSHIP = 'globalrolememberships';
type APIUserGlobalRoleMembershipDeleteParams = {
    tenantId: string;
    userId: string;
    globalRoleId?: string;
};

export const APIUserGlobalRoleMembershipDelete: APIMethod<APIUserGlobalRoleMembershipDeleteParams, APIBaseResponse> = (params) => {
    const queryParams = buildQueryParams(params);
    const requestPath = `${TENANTS_PATH_PREFIX}/${params.tenantId}/${GLOBAL_ROLE_MEMBERSHIP}` + (queryParams && `?${queryParams}`);
    return _request('DELETE', requestPath);
};
